/**
 * Core Z-Index Tokens — Tier 1
 *
 * Raw z-index layer scale.
 * JS key maps to Figma token: zIndex.modal → z-index-modal.
 *
 * Rules:
 * - Tier 2 semantic tokens reference these keys; never raw values
 */

export const zIndex = {
  base: 0,
  dropdown: 100,
  sticky: 110,
  overlay: 200,
  modal: 300,
  popover: 400,
  tooltip: 500,
} as const;

export type ZIndex = typeof zIndex;
export type ZIndexToken = keyof ZIndex;
